module.exports = __webpack_public_path__ + "img/4.41bf9deb.svg";